export default __webpack_public_path__ + "static/media/GoDaddy_Login_page.07f8840e.webp";